import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'tr', label: 'TR', name: 'Türkçe' },
  { code: 'fr', label: 'FR', name: 'Français' },
];

const LanguageSwitcher = ({ variant = 'dropdown' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);

  const current =
    languages.find((lang) => i18n.language?.startsWith(lang.code)) || languages[0];

  useEffect(() => {
    if (variant !== 'dropdown') return undefined;
    const onClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [variant]);

  if (variant === 'segmented') {
    return (
      <div className="arc-lang-seg" role="group" aria-label="Language">
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            className={`arc-lang-seg-btn ${lang.code === current.code ? 'is-active' : ''}`}
            onClick={() => i18n.changeLanguage(lang.code)}
            aria-pressed={lang.code === current.code}
          >
            {lang.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={`arc-lang ${isOpen ? 'is-open' : ''}`} ref={rootRef}>
      <button
        type="button"
        className="arc-lang-btn"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((v) => !v)}
      >
        <span>{current.label}</span>
        <span className="arc-lang-caret" aria-hidden="true" />
      </button>

      {isOpen && (
        <div className="arc-lang-menu" role="listbox">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              role="option"
              aria-selected={lang.code === current.code}
              className={`arc-lang-option ${lang.code === current.code ? 'is-active' : ''}`}
              onClick={() => {
                i18n.changeLanguage(lang.code);
                setIsOpen(false);
              }}
            >
              <strong>{lang.label}</strong>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
